import { type PreparedPhotoSwipeOptions } from "photoswipe";

export const options: Partial<PreparedPhotoSwipeOptions> = {
    gallery: "#pswp-gallery-container",

    // Elements within gallery (slides)
    children: ".pswp-gallery__item",

    zoom: false,
    arrowPrev: false,
    arrowNext: false,
    close: false,
    counter: false,

    showHideAnimationType: "none",

    paddingFn: (viewportSize: { x: number; y: number }) => {
        const viewPortHeightBreakpoint = 600;

        const paddingX = viewportSize.y <= viewPortHeightBreakpoint ? 50 : 32;
        // if viewport height is less than 600px, use less padding on top than botttom
        const paddingTop = viewportSize.y <= viewPortHeightBreakpoint ? 50 : 150;
        const paddingBottom = viewportSize.y <= viewPortHeightBreakpoint ? 100 : 150;

        return { top: paddingTop, bottom: paddingBottom, left: paddingX, right: paddingX };
    },

    // setup PhotoSwipe Core dynamic import
    pswpModule: () => import("photoswipe"),
};
